var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{on:{"loginFailed":_vm.onFailedAuthentication}},[_c('Header'),_c('div',{staticClass:"wrap-home f fh"},[_c('span',{on:{"click":_vm.logout}},[_vm._v("Sign Out")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }